import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-toastify/dist/ReactToastify.css'

import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import RoutesFunction from './routes'
import { ToastContainer } from 'react-toastify'
import AppProviders from './hooks'

function App() {
  return (
    <AppProviders>
      <BrowserRouter>
        <RoutesFunction />
        <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </BrowserRouter>
    </AppProviders>
  )
}

export default App
